import { useMutation } from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import { parseErrors } from 'src/app/utilities/helpers/errors';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const useApplyTicketLinkImport = (onSuccess?: () => void) => {
    return useMutation({
        mutationFn: (ticketLinkImportId: string) =>
            ticketLinkImportService.applyTicketLinkImport(ticketLinkImportId),
        onSuccess: () => {
            Toaster.toast('Applying ticket link import!', { variant: 'success' });
            onSuccess?.();
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};
